<template>
  <div>
    <div
      v-if="merchant.userSignUpFields.firstName || merchant.userSignUpFields.lastName"
      class="cf-combined-inputs"
    >
      <cf-text-input
        v-if="merchant.userSignUpFields.firstName"
        type="text"
        label="First Name"
        name="firstNameCreateAccount"
        autocomplete="given-name"
        icon-class="fa-user-circle"
        :show-as-optional="true"
        :validations="{
          name: true,
          required: merchant.userSignUpFields.firstName.isRequired
        }"
        :model-value="firstName"
        @keypress.space.prevent="focusLastName"
        @blur="blurHandler"
        @update:model-value="firstNameInputHandler"
        @focus="focusHandler"
      />

      <cf-text-input
        v-if="merchant.userSignUpFields.lastName"
        ref="lastNameInput"
        type="text"
        label="Last Name"
        name="lastNameCreateAccount"
        autocomplete="family-name"
        :show-as-optional="true"
        :validations="{
          name: true,
          required: merchant.userSignUpFields.lastName.isRequired
        }"
        :model-value="lastName"
        @blur="blurHandler"
        @update:model-value="lastNameInputHandler"
        @focus="focusHandler"
      />
    </div>

    <cf-text-input
      v-else-if="merchant.userSignUpFields.fullName || fullName"
      type="text"
      label="Full Name"
      name="fullNameCreateAccount"
      autocomplete="name"
      icon-class="fa-user-circle"
      :show-as-optional="true"
      :validations="{
        full_name: true,
        required: merchant.userSignUpFields.fullName && merchant.userSignUpFields.fullName.isRequired
      }"
      :model-value="fullName"
      @blur="blurHandler"
      @update:model-value="fullNameInputHandler"
      @focus="focusHandler"
    />
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfTextInput from '../cf-text-input/index.vue';


  export default {
    name: 'FullNameInput',

    components: {
      CfTextInput
    },

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      modelValue: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        firstName: '',
        fullName: '',
        isFocused: false,
        lastName: ''
      };
    },

    computed: {
      ...mapGetters('merchant', ['merchant'])
    },

    watch: {
      modelValue: {
        handler: 'updateInternalValue',
        immediate: true
      }
    },

    methods: {
      blurHandler() {
        this.isFocused = false;
      },

      firstNameInputHandler(value) {
        this.firstName = value;
        const fullName = `${this.firstName} ${this.lastName}`.trim();
        this.$emit('update:modelValue', fullName);
      },

      focusHandler() {
        this.isFocused = true;
      },

      focusLastName() {
        this.$refs.lastNameInput.focus();
      },

      fullNameInputHandler(value) {
        this.fullName = value;
        this.$emit('update:modelValue', this.fullName);
      },

      lastNameInputHandler(value) {
        this.lastName = value;
        const fullName = `${this.firstName} ${this.lastName}`.trim();
        this.$emit('update:modelValue', fullName);
      },

      updateInternalValue(value) {
        if (this.isFocused && this.fullName) {
          return;
        }

        const fullName = value || '';
        const nameSegments = fullName.trim().split(' ');
        const firstName = nameSegments.shift();
        const lastName = nameSegments.join(' ');

        this.firstName = firstName;
        this.fullName = fullName;
        this.lastName = lastName;
      }
    }
  };
</script>
